
import { Product } from "@/types/product";
import { vpxProducts } from "./1gb";
import { ipxProducts } from "./10gb";
import { vpxAccessories } from "./accessories";

// Define the software product
const softwareProducts: Product[] = [
  {
    id: "ipbaset-manager",
    groupId: "avoip",
    name: "IPBaseT Manager",
    subtitle: "Comprehensive control application for IPX, VPX, and VLX series",
    description: `Aurora's IPBaseT Manager software is an all in one control application for the IPX, VPX, and VLX series of Aurora IPBaseT AV over IP products. This intuitive software not only allows for simple drag-and-drop signal routing, but also includes powerful utilities for configuring and managing your Aurora AVoIP system.

Whether you have 5 or 500 transceivers on your network, IPBaseT Manager can make setup a breeze. The Aurora exclusive Rapid Deployment Tool allows you to scan the network and download configuration for all transceivers to a spreadsheet. Open with your favorite spreadsheet editor and quickly define complete configuration for each device. Finally, save the file and import back into IPBaseT Manager, and it will send out configuration details to all units on the network.

IPBaseT Manager also includes a variety of other features*. Simple video wall setup, video preview routing, picture-in-picture and multi-image processing setup, and a powerful EDID editor are all part of IPBaseT Manager. Breakaway routing for audio, serial, IR, and USB, as well as batch firmware updating and more make IPBaseT Manager an all-in-one solution for managing IPBaseT installations.

IPBaseT Manager is available for download via our customer portal.

*certain features are specific to IPX, VPX, or VLX series hardware`,
    features: [
      "Device auto-discovery",
      "Matrix routing",
      "Seamless switching",
      "Multiview configuration and routing",
      "Videowall setup",
      "Break-away line audio routing",
      "Break-away HDMI audio routing",
      "Break-away serial routing",
      "Break-away IR routing",
      "Break-away USB routing",
      "Macro recall",
      "Batch firmware update",
      "Serial and IR send/receive terminal",
      "Comprehensive EDID editor",
      "Rapid Deployment Tool",
      "Live preview routing",
      "IPX Series & VPX Series"
    ],
    images: ["/lovable-uploads/609cd1fc-ebb7-4b5b-8731-f0e7c5722774.png"],
    slug: "ipbaset-manager",
    networkSpeed: "software"
  }
];

export const avoipProducts: Product[] = [...vpxProducts, ...ipxProducts, ...vpxAccessories, ...softwareProducts];

export const getAVOIPProductsBySpeed = (speed: "1gb" | "10gb" | "vpx-accessories" | "software"): Product[] => {
  if (speed === "vpx-accessories") {
    return vpxAccessories;
  }
  if (speed === "software") {
    return softwareProducts;
  }
  return avoipProducts.filter(product => product.networkSpeed === speed);
};
